import { cn } from "@/lib/utils"
import { testIds } from "@/lib/test-ids"

export interface WorkspaceSearchBadgeProps {
  abbreviation: string
  color: string | null
  name: string
  className?: string
}

/**
 * Compact workspace indicator for search rows (command palette, sidebar search).
 */
function hexWithAlpha(hex: string, alphaHex: string): string | undefined {
  if (/^#[0-9A-Fa-f]{6}$/.test(hex)) return `${hex}${alphaHex}`
  return undefined
}

export function WorkspaceSearchBadge({
  abbreviation,
  color,
  name,
  className,
}: WorkspaceSearchBadgeProps) {
  const bg = color ? hexWithAlpha(color, "33") : undefined
  return (
    <span
      title={name}
      data-testid={testIds.workspaceSearchBadge.root}
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded border px-1 py-px text-[9px] font-semibold leading-none tabular-nums tracking-tight",
        !color && "border-border bg-muted/80 text-muted-foreground",
        className,
      )}
      style={
        color
          ? {
              borderColor: color,
              ...(bg ? { backgroundColor: bg } : {}),
              color,
            }
          : undefined
      }
    >
      {abbreviation}
    </span>
  )
}
